import { Filters } from "@costory/types/filters"

import { DonutChart } from "@costory/front/components/charts/DonutChart"
import { KPICardChart } from "@costory/front/components/charts/KPICard"
import { KPIChart } from "@costory/front/components/charts/KPIChart"
import { StackedBarChart } from "@costory/front/components/charts/StackedBarChart"
import { WaterfallChart } from "@costory/front/components/charts/WaterfallChart"
import { ChartType } from "@costory/front/components/dashboard/constants"

type Props = {
  chartType: ChartType
  filters: Filters
  height?: number
  withLegend?: boolean
  embed?: boolean
  isAnimationActive?: boolean
  isDashboardWidget?: boolean
}

export const Chart = ({
  chartType,
  filters,
  height,
  withLegend = true,
  embed,
  isAnimationActive = true,
  isDashboardWidget = false,
}: Props) => {
  switch (chartType) {
    case "TREND":
      return (
        <StackedBarChart
          filters={filters}
          height={height}
          withLegend={withLegend}
          isAnimationActive={isAnimationActive}
          isDashboardWidget={isDashboardWidget}
        />
      )
    case "DONUT":
      return (
        <DonutChart
          filters={filters}
          height={height}
          isAnimationActive={isAnimationActive}
        />
      )
    case "WATERFALL":
      return (
        <WaterfallChart
          filters={filters}
          height={height}
          withLegend={withLegend}
          dashboardChartConfig={75}
          embed={embed}
          tooltipYPosition={height && height / 2}
          isAnimationActive={isAnimationActive}
        />
      )
    case "KPI":
      return <KPICardChart filters={filters} />
    case "KPI_BREAKDOWN":
      return <KPIChart filters={filters} withBreakdown />
  }
}
